// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-icon-button":"sapcnqr-icon-button-71b593","sapcnqr-icon-button--lg":"sapcnqr-icon-button--lg-5556a0","sapcnqr-icon-button--wide":"sapcnqr-icon-button--wide-dd1dbd"};